/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavedViewBase {
    getFixupPrototypeFunction() { return SavedViewBase.fixupPrototype; }

    static newInstance(model: Partial<SavedViewBase>): SavedViewBase {
        let obj = Object.assign(new SavedViewBase(), model);
        SavedViewBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavedViewBase>): SavedViewBase {
        if (!model) return null;
        return SavedViewBase.newInstance(<SavedViewBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavedViewBase) {
        if (!obj) return;

        models.SavedViewBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavedViewBase): boolean {
        Object.setPrototypeOf(obj, SavedViewBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.view) {
            models.ViewState.fixupPrototype(this.view);
        }
    }

    /**
     * View label
     */
    name: string;

    module: models.SavedViewModule;

    /**
     * Dashboard this view belongs to
     */
    dashboard_id: string;

    visibility: models.SavedViewVisibility;

    /**
     * Role-based access metadata, e.g. ['admin', 'finops_viewer']
     */
    roles: Array<string>;

    /**
     * Polymorphic view payload (DashboardViewState)
     */
    view: models.ViewState;

}
